import React from "react";
import { Skeleton } from "@/components/ui/skeleton";
import { Card, CardContent } from "@/components/ui/card";

export const MerchandiseProductDetailSkeleton = () => {
  return (
    <div className="space-y-6 p-6 max-w-5xl">
      {/* Header */}
      <div className="flex items-center gap-4 mb-6 justify-between">
        <div className="flex items-center gap-4">
          <Skeleton className="h-9 w-16" />
          <div>
            <Skeleton className="h-8 w-64 mb-2" />
            <Skeleton className="h-4 w-80" />
          </div>
        </div>
        <Skeleton className="h-10 w-32" />
      </div>

      {/* Product card */}
      <Card className="border-0 shadow-sm overflow-hidden bg-white">
        <CardContent className="p-6 space-y-6">
          {/* Product header */}
          <div className="flex items-center gap-6">
            <Skeleton className="h-24 w-24 rounded-lg" />
            <div>
              <Skeleton className="h-8 w-64 mb-2" />
              <div className="flex flex-wrap gap-4 mb-1">
                <Skeleton className="h-4 w-32" />
              </div>
              <div className="flex flex-wrap gap-4">
                <Skeleton className="h-4 w-40" />
                <Skeleton className="h-4 w-44" />
              </div>
            </div>
          </div>

          {/* Separator */}
          <div className="border-t border-gray-200 my-2" />

          {/* Description */}
          <div className="space-y-2">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-3/4" />
            <Skeleton className="h-4 w-1/2" />
          </div>

          {/* Product details grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
            {[...Array(8)].map((_, index) => (
              <div key={index} className="flex gap-2">
                <Skeleton className="h-4 w-20" />
                <Skeleton className="h-4 w-24" />
              </div>
            ))}
          </div>

          {/* Product attributes table */}
          <div className="mt-6">
            <Skeleton className="h-5 w-40 mb-2" />
            <div className="border rounded">
              <div className="border-b p-2">
                <div className="flex">
                  <Skeleton className="h-4 w-24 mr-4" />
                  <Skeleton className="h-4 w-32" />
                </div>
              </div>
              <div className="p-2">
                <div className="flex">
                  <Skeleton className="h-4 w-20 mr-4" />
                  <Skeleton className="h-4 w-28" />
                </div>
              </div>
            </div>
          </div>

          {/* Separator */}
          <div className="border-t border-gray-200 my-4" />

          {/* Terms & Conditions */}
          <div>
            <Skeleton className="h-5 w-40 mb-2" />
            <div className="space-y-2">
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-3/4" />
              <Skeleton className="h-4 w-1/2" />
            </div>
          </div>

          {/* How To Use */}
          <div className="mt-4">
            <Skeleton className="h-5 w-32 mb-2" />
            <div className="space-y-2">
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-2/3" />
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
